/**
 *
 * Styles for SpecialOfferInfo
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { Headline } from "root/libs/ui-components/src";

import { breakpoints } from "root/libs/ui-styleguide/src";

export const StyledFirstLine = styled(DhlText)`
  & > *:is(p, span) {
    color: var(--dui-color-black-500);
    margin: 0;
    margin-bottom: var(--gaq-size-space-7px);
  }
`;

export const HeadlineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: var(--gaq-size-space-5px);
  margin-bottom: var(--gaq-size-space-15px);

  @media screen and (min-width: ${breakpoints.desktop}) {
    line-height: 24px;
    flex-direction: row;
    display: inline-flex;
    margin-bottom: var(--dui-size-space-4x);
    align-items: center;
  }
`;

export const OfferFeaturesWrapper = styled.div`
  margin-top: var(--dui-size-space-5x);

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
    padding-left: var(--dui-size-space-5x);
    margin-left: var(--dui-size-space-5x);
    border-left: var(--dui-size-width-border-sm) solid var(--dui-color-gray-300);
  }
`;

export const StyledHeadline = styled(Headline)`
  display: flex;
  flex-direction: column;
  margin: 0;
  white-space: normal;

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    display: inline-flex;
    max-width: 33.5rem;
  }
`;

export const StyledHeadlineAddition = styled.span`
  font-size: 2rem;
  font-weight: 200;
  font-stretch: normal;
  margin-top: calc(var(--dui-size-space-7x) / 2);

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
    padding-left: var(--dui-size-space-5x);
    margin-left: var(--dui-size-space-5x);
    border-left: var(--dui-size-width-border-sm) solid var(--dui-color-gray-300);

    &.text--giga.text--giga {
      line-height: 1;
    }
  }
`;

export const StyledPromotedLine = styled(DhlText)`
  min-height: 32px;
  min-height: 11%;
`;
